import EditCategory from './EditCategory'

export default EditCategory



// WEBPACK FOOTER //
// ./src/components/Categories/Edit/index.js